import { map, mergeMap, tap, filter, catchError } from 'rxjs/operators'
import { of } from 'rxjs'
import { ofType, combineEpics } from 'redux-observable'

import { WALLET_STORAGE, TC_ACTIONS, WALLET_CREATE, WALLET_RESTORE, BRANDING_ACTIONS } from '../../constants/actions'
import storage from '../../services/storage'
import { logger } from '../../util/helpers'
import brandingService from '../../services/branding'


const handleCheckPolicyStorage = action$ => action$.pipe(
  ofType(WALLET_STORAGE.ON_WALLET_FOUND),
  mergeMap(() => of(storage.getTCPolicy()).pipe(
    tap(policy => logger(policy)),
    map(policy => ({ type: TC_ACTIONS.ON_GET_POLICY_FROM_STORAGE, payload: policy }))
  ))
)

const handleAcceptPolicyStorage = action$ => action$.pipe(
  ofType(TC_ACTIONS.ON_ACCEPT_TC, WALLET_CREATE.ON_WALLET_CREATED, WALLET_RESTORE.ON_WALLET_RESTORED),
  mergeMap(() => of(storage.acceptTC()).pipe(
    map(_ => ({ type: TC_ACTIONS.ON_TC_ACCEPTED }))
  ))
)

const handleGetBrandData = action$ => action$.pipe(
  ofType(BRANDING_ACTIONS.ON_GET_BRAND_DATA),
  filter(action => action.payload),
  mergeMap(action => brandingService.getBrandData$(action.payload).pipe(
    tap(data => logger(data)),
    map(data => ({ 
      type: data.response ? BRANDING_ACTIONS.ON_BRAND_DATA_RECEIVED : BRANDING_ACTIONS.ON_BRAND_DATA_NO_DATA,
      payload: data.response
    })),
    catchError(_ => of({
      type: BRANDING_ACTIONS.ON_BRAND_DATA_NO_DATA,
    }))
  ))
)

export const authEpic = combineEpics(
  handleCheckPolicyStorage,
  handleAcceptPolicyStorage,
  handleGetBrandData
)



// WEBPACK FOOTER //
// ./src/store/epics/auth.js